define('views/modules/calendar/animated-session/exercise/lists/print/print-exercise-separator',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/lists/print/print-exercise-separator.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // templates
    TPrintExerciseSeparator
) {

    var VPrintExerciseSeparator = Backbone.Epoxy.View.extend({
        template: TPrintExerciseSeparator,
        events: {
            'click .exercise-link': 'onLinkClick',
        },

        linkClass: {
            large: "tc-visible-lg",
            small: "tc-visible-sm"
        },

        initialize: function(opt) {
            opt = opt || {};

            _.extend(this, {
                role: opt.role
            });

            this.listenTo(this.model, "destroy", this.remove);

        },
        render: function() {

            var data = Mustache.getContext(this.model.toJSON());

            this.setElement(Mustache.render(this.template, data));

            this.applyBindings();

            return this;
        },

    });

    return VPrintExerciseSeparator;

});

